import { useState } from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO, REVIEWS } from '../data/staticData';
import ContactForm from '../components/ContactForm';

export default function EnergySolutionsPage() {
  const [openFaq, setOpenFaq] = useState([0]);

  const energyFaqs = [
    {
      q: 'Hvad koster det at få efterisoleret?',
      a: 'Prisen på isolering af loftsrum afhænger af, hvor mange kvadratmeter dit loft er i grundplan. Derudover skal vi vide, hvor lang gangbroen er, og hvor mange lag isolering, du ønsker. Her kan du vælge mellem 100-450 mm, hvor det nuværende krav til boliger dog er, at der skal være minimum 300 mm. isolering og 400 mm. for lavenergihuse. Har du prøvet vores prisberegner på loftisolering? Her kan du få en mere konkret pris på isolering af dit hus.'
    },
    {
      q: 'Hvorfor er det en god idé at få efterisoleret sin bolig?',
      a: 'Vi anbefaler som udgangspunkt, at du sørger for at efterisolere dit loft, hvis der er mindre end 175 mm. isolering. Det gælder for stort set alle ældre huse, der er mere end 10 år gamle, og som aldrig har fået lagt ekstra isolering ind. Står I overfor en større ombygning, tilbygning eller renovering kan man også med fordel få efterisoleret i samme omgang, da isolering er en investering i boligens samlede værdi.'
    },
    {
      q: 'Hvorfor skal jeg skifte boligens vinduer/døre?',
      a: 'Har du vinduer, der er meget slidte, medtagede eller ligefrem i stykker, kan det sjældent betale sig at restaurere dem. Udover at det tidsmæssigt – og ofte også økonomisk – ikke sparer dig for penge, så vil de ældre vinduer ikke leve op til nutidens energikrav. Står du i en sådan situation, eller oplever du gener, herunder træk, dug på indersiden, nedslidt eller råddent træ, kan du med fordel skifte dine vinduer og/eller døre. Nye vinduer/døre vil foruden at give et nyt, mere moderne look til huset, også mindske din varmeregning markant.'
    },
    {
      q: 'Hvordan påvirker mit nye tag varmeforbruget i min bolig?',
      a: 'Fokusset på energirenovering og -optimering af boligen er højere end nogensinde, og der findes flere muligheder for at spare både klima og pengepung for unødig energi. Faktisk sker omtrent 25 % af varmetabet i en almindelig husstand gennem loftet og taget, hvorfor nyt tag, efterisolering samt energirigtige vinduer/døre er en rigtig god idé at investere i. Der kan som regel altid gøres noget for at energioptimere en bolig, og vi anbefaler, at man tager fat i professionelle fagfolk, som kan tilse boligens stand og rådgive i de rigtige løsninger.'
    },
    {
      q: 'Hvad er kravene til energioptimering i dag?',
      a: 'Reglerne til energioptimering af boligen er strammere i dag, og som husejere er det dit ansvar, at du lever op til kravene. Det kræves i dag, at alle husejere, som bygger nyt, bygger til eller bygger om, bruger vinduer, der svarer til energiklasse A, hvilket normalt er 3-lags glas eller såkaldte A-mærkede vinduer. B-mærkede elementer med 2-lags glas er kun tilladt i sommerhuse og uopvarmede rum. Samtidig er der krav om minimum 300 mm. isolering i alm. huse og 400 mm. for lavenergihuse.'
    }
  ];

  const toggleFaq = (idx) => {
    setOpenFaq((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );
  };

  const solutions = [
    {
      title: 'Isolering',
      subtitle: 'Hold på varmen og få forbedret indeklima',
      desc: 'Er dit loftsrum og tag ikke tilstrækkeligt isoleret, vil din bolig have et højt varmetab, og det kan også skabe et usundt og ubehageligt indeklima. Med efterisolering af boligen kan du...',
      link: '/ydelser/isolering',
      image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-2_d903f47c.webp'
    },
    {
      title: 'Nye vinduer og døre',
      subtitle: 'Nyt visuelt udtryk med energirigtige vinduer og døre',
      desc: 'Der stilles i dag højere krav til boligens vinduer og døre, og med nye energiforbedrede vinduer og døre kan du imødekomme disse krav samt spare penge, øge salgsværdien på huset, få...',
      link: '/ydelser/vinduer-og-doere',
      image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-3_ff8c4038.webp'
    },
    {
      title: 'Solceller på tag',
      subtitle: 'Få vejledning til den rigtige solcelleløsning',
      desc: 'Overvejer du at få solceller på dit tag? Flere og flere boligejere vælger solceller for at producere deres egen strøm, reducere elregningen og gøre boligen mere energieffektiv. Hos...',
      link: '/ydelser/solceller',
      image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-4_dd434935.webp'
    }
  ];

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 lg:pt-20 pb-12 sm:pb-16 border-b border-stone-200">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-8 space-y-6">
            <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-stone-900 tracking-tight uppercase">
              Få hjælp til at energioptimere din bolig
            </h1>
            <div className="space-y-4 text-stone-700 text-base sm:text-lg leading-relaxed">
              <p>
                Flere og flere vælger i dag at få efterisoleret deres hus og få udskiftet døre og vinduer for at energioptimere boligen, så den nu og i fremtiden imødekommer de strengere krav og de høje energipriser, der kan være hårde for pengepungen.
              </p>
              <p>
                Hos Dansk Tagbyg er vi specialister i energiløsninger til boligen, herunder{' '}
                <Link to="/c/ydelser/solceller" className="text-[#BE0F12] font-semibold underline hover:text-black">
                  solceller
                </Link>
                , efterisolering af tag samt udskiftning af vinduer og døre. Vi kender til de forskellige muligheder, der er for energioptimering af boligen, og vi hjælper med alt fra rådgivning i emnet til eksekveringen.
              </p>
              <p>
                Drømmer du om at få foretaget en energirenovering af dit hus, som kan forbedre energimærkningen, gøre dit indeklima mere behageligt og øge salgsværdien på dit hus, er du velkommen til at tage fat i os, så hjælper vi dig godt i mål til gode og konkurrencedygtige priser.
              </p>
            </div>

            {/* Quick Links */}
            <div className="pt-4 border-t border-stone-200">
              <p className="text-xs font-bold uppercase tracking-wider text-stone-500 mb-3">
                Klik og kom længere ned på siden:
              </p>
              <div className="flex flex-wrap gap-4 text-sm font-bold">
                <a href="#mulige-energiloesninger" className="text-stone-900 hover:text-[#BE0F12] underline">
                  Mulige energiløsninger
                </a>
                <span className="text-stone-300">•</span>
                <a href="#faq" className="text-stone-900 hover:text-[#BE0F12] underline">
                  Find svar på ofte stillede spørgsmål
                </a>
                <span className="text-stone-300">•</span>
                <a href="#udtalelser" className="text-stone-900 hover:text-[#BE0F12] underline">
                  Det siger andre kunder
                </a>
                <span className="text-stone-300">•</span>
                <a href="#kontakt" className="text-stone-900 hover:text-[#BE0F12] underline">
                  Kontakt os
                </a>
              </div>
            </div>
          </div>

          {/* Right Callout Box: Prisberegner isolering */}
          <div className="lg:col-span-4 space-y-6">
            <div className="bg-stone-50 border border-stone-200 p-6 sm:p-8 space-y-4">
              <h3 className="text-lg font-bold text-stone-900 uppercase">
                Få et uforpligtende tilbud – Prisberegner: Loftisolering
              </h3>
              <p className="text-sm text-stone-600 leading-relaxed">
                Ud fra 4 simple spørgsmål beregner vi med det samme en uforpligtende pris til dig på efterisolering af dit loft. Hurtigt og nemt!
              </p>
              <Link
                to="/prisberegner-isolering"
                className="inline-block w-full text-center px-6 py-3 bg-[#BE0F12] hover:bg-[#a00d0f] text-white font-bold text-sm tracking-wider uppercase transition-colors"
              >
                Prisberegner: Loftisolering
              </Link>
            </div>

            {/* Lasse profilbillede */}
            <div className="flex flex-row items-end justify-center gap-2 sm:gap-3 pt-2">
              <img
                src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/har-du-sporgsmaal.png"
                alt="Har du spørgsmål, så tag fat i mig!"
                className="w-[42%] max-w-[145px] h-auto object-contain self-center"
              />
              <img
                src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/lasse-sidebar.png"
                alt="Lasse Vesterhouen - Dansk Tagbyg"
                className="w-[58%] max-w-[200px] h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Mulige energiløsninger */}
      <section id="mulige-energiloesninger" className="py-16 sm:py-20 bg-stone-50 border-b border-stone-200 scroll-mt-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          <div className="max-w-3xl">
            <h2 className="text-2xl sm:text-4xl font-extrabold text-stone-900 uppercase">
              Mulige energiløsninger
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {solutions.map((item, idx) => (
              <div key={idx} className="bg-white border border-stone-200 overflow-hidden shadow-sm flex flex-col justify-between">
                <div className="h-56 bg-stone-100 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 sm:p-8 space-y-3">
                  <h3 className="text-xl font-extrabold text-stone-900 uppercase">
                    {item.title}
                  </h3>
                  <h4 className="text-sm font-bold text-stone-700">
                    {item.subtitle}
                  </h4>
                  <p className="text-stone-600 text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
                <div className="p-6 sm:p-8 pt-0">
                  <Link
                    to={item.link}
                    className="text-xs font-bold text-[#BE0F12] uppercase tracking-wider hover:underline"
                  >
                    Læs mere →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sektion: Find svar på ofte stillede spørgsmål */}
      <section id="faq" className="py-16 sm:py-20 bg-white border-b border-stone-200 scroll-mt-28">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <h2 className="text-2xl sm:text-4xl font-extrabold text-stone-900 uppercase">
            Find svar på ofte stillede spørgsmål
          </h2>

          <div className="space-y-3">
            {energyFaqs.map((faq, idx) => {
              const isOpen = openFaq.includes(idx);
              return (
                <div key={idx} className="bg-stone-50 border border-stone-200">
                  <button
                    onClick={() => toggleFaq(idx)}
                    className="w-full py-4 px-6 text-left flex justify-between items-center gap-4 hover:bg-stone-100 transition-colors"
                  >
                    <span className="font-bold text-stone-900 text-base sm:text-lg">
                      {faq.q}
                    </span>
                    <span className="text-[#BE0F12] font-black text-xl shrink-0">
                      {isOpen ? '−' : '+'}
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-6 pb-5 pt-1 text-stone-700 text-sm sm:text-base leading-relaxed border-t border-stone-200">
                      <p>{faq.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Kontakt mig, Lasse boks */}
      <section className="py-12 bg-stone-50 border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white border border-stone-200 p-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
            <div>
              <h3 className="text-2xl font-extrabold text-stone-900 uppercase">
                Kontakt mig, Lasse
              </h3>
              <p className="text-stone-600 text-sm mt-1">
                Få kompetent rådgivning om efterisolering, vinduer og energiløsninger.
              </p>
            </div>
            <div className="flex flex-wrap gap-4 text-sm font-bold">
              <a
                href={`tel:${COMPANY_INFO.phone}`}
                className="px-6 py-3 bg-stone-900 hover:bg-black text-white transition-colors"
              >
                Ring: {COMPANY_INFO.phoneFormatted}
              </a>
              <a
                href={`mailto:${COMPANY_INFO.email}`}
                className="px-6 py-3 bg-white border border-stone-300 hover:bg-stone-100 text-stone-800 transition-colors"
              >
                Skriv: {COMPANY_INFO.email}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Udtalelser sektion */}
      <section id="udtalelser" className="py-16 sm:py-20 bg-white border-b border-stone-200 scroll-mt-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          <div className="max-w-3xl">
            <h2 className="text-2xl sm:text-4xl font-extrabold text-stone-900 uppercase">
              Vi motiveres af glade kunder og gode resultater
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {REVIEWS.map((rev) => (
              <div key={rev.id} className="p-6 bg-stone-50 border border-stone-200 space-y-4 shadow-sm flex flex-col justify-between">
                <div className="space-y-3">
                  <div className="flex text-amber-500 text-sm">
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                  </div>
                  <p className="text-stone-700 text-sm leading-relaxed italic">
                    "{rev.text}"
                  </p>
                </div>
                <div className="pt-2 border-t border-stone-200">
                  <p className="font-bold text-stone-900 text-sm">{rev.name}</p>
                  <p className="text-xs text-stone-500">{rev.location}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center pt-4">
            <div className="inline-flex items-center gap-2 p-4 bg-stone-50 border border-stone-200">
              <span className="font-extrabold text-stone-900 text-lg">4,8 ud af 155 anmeldelser</span>
              <span className="text-stone-300">•</span>
              <span className="text-sm font-semibold text-stone-600">Finalist til Årets Håndværker 5 år i træk</span>
            </div>
          </div>
        </div>
      </section>

      {/* Bund: Kontaktformular */}
      <section id="kontakt" className="py-16 sm:py-24 bg-stone-100 scroll-mt-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 sm:gap-16 items-start">
            
            {/* Venstre kolonne */}
            <div className="lg:col-span-5 space-y-8">
              <div className="p-6 bg-white border border-stone-200 shadow-sm space-y-3">
                <div className="flex items-center gap-1 text-amber-500 text-lg">
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                </div>
                <a
                  href="https://www.anmeld-haandvaerker.dk/tagdaekker/dansk-tagbyg-aps"
                  target="_blank"
                  rel="noreferrer"
                  className="block font-black text-xl text-stone-900 hover:text-[#BE0F12] transition-colors"
                >
                  4,8 ud af 155 anmeldelser
                </a>
                <p className="text-xs text-stone-500">
                  Finalist til Årets Håndværker 5 år i træk
                </p>
              </div>

              <div className="p-6 bg-white border border-stone-200 shadow-sm space-y-4 text-sm text-stone-700">
                <h3 className="font-extrabold text-xl text-stone-900 uppercase">
                  Dansk Tagbyg ApS
                </h3>
                <div className="space-y-2">
                  <p>
                    <strong className="text-stone-900">Ring:</strong>{' '}
                    <a href={`tel:${COMPANY_INFO.phone}`} className="text-[#BE0F12] font-bold hover:underline">
                      {COMPANY_INFO.phoneFormatted}
                    </a>
                  </p>
                  <p>
                    <strong className="text-stone-900">Skriv:</strong>{' '}
                    <a href={`mailto:${COMPANY_INFO.email}`} className="text-[#BE0F12] font-bold hover:underline">
                      {COMPANY_INFO.email}
                    </a>
                  </p>
                  <p>
                    <strong className="text-stone-900">Adr:</strong> {COMPANY_INFO.address}
                  </p>
                  <p>
                    <strong className="text-stone-900">CVR:</strong> {COMPANY_INFO.cvr}
                  </p>
                </div>
                <div className="pt-3 border-t border-stone-200">
                  <p className="font-bold text-stone-900">Vi løser opgaver i hele DK</p>
                </div>
                <div className="pt-2">
                  <p className="text-xs font-bold text-stone-500 uppercase tracking-wider mb-2">Vi er medlem af</p>
                  <div className="flex flex-wrap gap-2 text-xs font-semibold text-stone-700">
                    <span className="px-2.5 py-1 bg-stone-100 border border-stone-200">Swisspearl</span>
                    <span className="px-2.5 py-1 bg-stone-100 border border-stone-200">Byg Garanti</span>
                    <span className="px-2.5 py-1 bg-stone-100 border border-stone-200">DI Byggeri</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Højre kolonne: Formular */}
            <div className="lg:col-span-7 bg-white border border-stone-200 p-8 sm:p-10 shadow-sm">
              <ContactForm
                idPrefix="energy"
                title="Kontakt os via formularen"
                subtitle="Vil du gerne have et uforpligtende tilbud på dit næste projekt, eller har du spørgsmål til, hvad vi kan hjælpe dig med? Du er altid velkommen til at kontakte os via kontaktformularen her, så vender vi tilbage hurtigst muligt."
                submitButtonText="Send"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
